import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { VerticaTableDataset } from 'app/model/dataset/vertica.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(VerticaTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class VerticaTableDatasetAdapter extends TabularTypeDatasetAdapter<VerticaTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: VerticaTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(VerticaTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: VerticaTableDataset): Promise<VerticaTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, VerticaTableDataset.MODEL);
    }
}
